
import CommonMix from './common.js'
export default {
    name: 'OperateGroup',
    mixins: [CommonMix],
    data() {
        return {

        }
    },
    props: {
        client: {},
        list: {},
        length: {},
        interval: {
            default() {
                return ['3rem', 3, 3, 4, 3]
            }
        },
        radio: {
            default: false
        },
        win: {
            default: true
        },
        transmit: {
            default: true // 部分玩法不支持单行走飞走飞
        },
        manipulation: {
            default: true
        },
        size: {
            default: 'mini'
        },
        showTotal: {
            default: true
        },
        doubleLine: {
            default: false // 有双重赔率要占用两行
        },
        fill: {
            default: false // 是否撑满
        },
        layout: {
            default: 'flex' //  布局模式
        },
        tableIndex: {
            default: 0
        },
        total: {},
        integration: {},
        repair: {
            default: 0 // 赔率修正
        },
        disabled: Boolean,
        specialHighlight: Boolean, // 是否自动高亮当前期特别号码
    },
    computed: {
        Interval() {
            let arr = []
            for (let i=0;i<=5;i++) {
                if (this.interval && this.interval[i]) {
                    arr.push(typeof this.interval[i] === 'number' ? `flex:${this.interval[i]};` : `width:${this.interval[i]};`)
                } else {
                    arr.push('flex:3;')
                }
            }
            return arr
        },
        TotalAmount() {
            if (this.total) {
                return this.total
            }
            try {
                let amount = 0
                let count = 0
                for (let item of this.list) {
                    let id = item.id
                    amount = this.Big(amount).add(item.amount).add(item.in_transfer).sub(item.out_transfer).toNumber()
                    if (item.number) {
                        count += item.number
                    }
                }
                let total = {
                    amount: this.Big(amount).round(2, 1).toNumber(),
                    count
                }
                this.$emit('total', {
                    index: this.tableIndex,
                    ...total
                })
                return total
            } catch (err) {
                return NaN
            }
        },
        capacity() {
            if (this.list && this.list.length) {
                let group = this.list[0].group_mark
                if (this.client.capacitys[group]) {
                    return this.client.capacitys[group]
                }
            }
            return null
        }
    },
    methods: {
        AmountTotal(item) {
            try {
                return this.Big(item.amount).add(item.in_transfer).sub(item.out_transfer).round(2, 1).toNumber()
            } catch (err) {
                return NaN
            }
        },
        WinTotal(item) {
            try {
                return this.Big(item.win).round(2, 0).toNumber()
            } catch (err) {
                return NaN
            }
        },
        TransmitCalcu(item) {
            // 顶级代理不参与补货计算
            if (this.Opt.isAdmin) {
                return 0
            }
            try {
                if (item.win < 0) {
                    let win = Math.abs(item.win)
                    let capacity = Math.abs(this.capacity)
                    let amount = this.Big(item.amount).add(item.in_transfer).sub(item.out_transfer).toNumber()
                    let transfer =  Math.ceil(this.Big(win).sub(capacity).div(item.odds).toNumber())
                    if (transfer > 0) {
                        return transfer > amount ? amount : transfer
                    }
                }
                return 0
            } catch (err) {
                return NaN
            }
        },
        IsSpecialHighlight(item) {
            // console.log (this.TabHistory,'this.TabHistory')
            const special_code = Number(this.TabHistory.special_code)
            if (special_code != String(this.TabHistory.special_code)) return false 
            if (this.specialHighlight && this.TabHistory.special_code) {
                if (this.TabHistory.special_code == item.name) return true
                else {

                    const key = item.name
                    const i = special_code
                    const [type, color] = this.BallType(special_code).split(' ')
                    const isOdd = special_code != 49 && special_code % 2 === 1
                    const isEven = special_code > 0 && special_code != 49 && special_code % 2 === 0
                    const isSamll = special_code >= 1 && special_code <= 24
                    const isBig = special_code >= 25 && special_code <= 48
 
                    const mouse = this.$store.state.base.options.lhc_mouse.split(',').map(Number);//lhc_mouse
                    const cattle = this.$store.state.base.options.lhc_cattle.split(',').map(Number);//lhc_cattle
                    const tiger = this.$store.state.base.options.lhc_tiger.split(',').map(Number);
                    const rabbit = this.$store.state.base.options.lhc_rabbit.split(',').map(Number);
                    const dragon = this.$store.state.base.options.lhc_dragon.split(',').map(Number);
                    const snake = this.$store.state.base.options.lhc_snake.split(',').map(Number);
                    const horse = this.$store.state.base.options.lhc_horse.split(',').map(Number);
                    const sheep = this.$store.state.base.options.lhc_sheep.split(',').map(Number);
                    const monkey = this.$store.state.base.options.lhc_monkey.split(',').map(Number);
                    const chicken = this.$store.state.base.options.lhc_chicken.split(',').map(Number);
                    const dog = this.$store.state.base.options.lhc_dog.split(',').map(Number);
                    const pig = this.$store.state.base.options.lhc_pig.split(',').map(Number);

                    const poultry = [...horse,...cattle,...sheep,...chicken,...dog,...pig];
                    const beast = [...mouse,...tiger,...rabbit,...dragon,...snake,...monkey];

                    if (item.name === '特单' && isOdd) return true
                    else if (item.name === '特双' && isEven) return true
                    else if (item.name === '特大' && isBig) return true
                    else if (item.name === '特小' && isSamll) return true

                    else if (key == '合单' || key == '合双' || key == '合大' || key == '合小') {
                        let number
                        if(special_code > 9){
                            let num = special_code;
                            const str_num = num.toString();
                            let number1 = parseInt(str_num[0]);
                            let number2 = parseInt(str_num[1]);
                            number = number1 + number2;
                        }else{
                            number = special_code;
                        }
                        if (number > 0 && key == '合单' && number % 2 === 1) return true
                        else if (number > 0 && key == '合双' && number % 2 === 0) return true
                        else if (number > 0 && key == '合大' && number > 6) return true
                        else if (number > 0 && key == '合小' && number <= 6) return true
                    }

                    else if (['特尾大', '特尾小'].includes(key)) {
                        if (i > 0 && key == '特尾大' &&  i % 10 > 4) return true
                        if (i > 0 && key == '特尾小' && i % 10 <= 4) return true
                    }
                    
                    else if (['合尾大', '合尾小'].includes(key)) {
                        let number = i;
                        if (i == 25) return false
                        if (i > 9) {
                            let num = i;
                            const str_num = num.toString();
                            let number1 = parseInt(str_num[0]);
                            let number2 = parseInt(str_num[1]);
                            number = number1 + number2;
                        }
                        if (number > 0 && key == '合尾大' && number%10 > 4) return true
                        if (number > 0 && key == '合尾小' && number%10 <= 4) return true
                    }

                    else if (key == '家禽' && poultry.includes(i)) return true
                    else if(key == '野兽' && beast.includes(i)) return true

                    else if (item.name === '红波' && color === 'red') return true
                    else if (item.name === '绿波' && color === 'green') return true
                    else if (item.name === '蓝波' && color === 'blue') return true

                    else if (key === '猪' && pig.includes(i)) return true
                    else if (key === '牛' && cattle.includes(i)) return true
                    else if (key === '虎' && tiger.includes(i)) return true
                    else if (key === '兔' && rabbit.includes(i)) return true
                    else if (key === '龙' && dragon.includes(i)) return true
                    else if (key === '蛇' && snake.includes(i)) return true
                    else if (key === '马' && horse.includes(i)) return true
                    else if (key === '羊' && sheep.includes(i)) return true
                    else if (key === '猴' && monkey.includes(i)) return true
                    else if (key === '鸡' && chicken.includes(i)) return true
                    else if (key === '狗' && dog.includes(i)) return true
                    else if (key === '鼠' && mouse.includes(i)) return true

                    else if (
                        (key.includes('红') && color === 'red') ||
                        (key.includes('绿') && color === 'green') ||
                        (key.includes('蓝') && color === 'blue')
                    ) {
                        if (key.includes('单') && isOdd) return true
                        else if (key.includes('双') && isEven) return true
                        else if (key.includes('大') && isBig) return true
                        else if (key.includes('小') && isSamll) return true
                    }

                    if (['总大', '总小', '总单', '总双'].includes(key)) {
                        const { total_num_single_double, total_num_big_small } = this.TabHistory
                        if (key === '总大' && total_num_big_small === '大') return true
                        else if (key === '总小' && total_num_big_small === '小') return true
                        else if (key === '总单' && total_num_single_double === '单') return true
                        else if (key === '总双' && total_num_single_double === '双') return true
                    }
                    // console.log(item, type, color, item.name, item.nnumber)
                }
            }
            return false
            // "special_code": "22",
            // "special_single_double": "单",
            // "special_big_small": "大",
            // BallType(str) {
            //     let type = 'text'
            //     if (str%1 === 0) {
            //         type = 'ball'
            //     }
            //     if (this.client.group == 'lhc') {
            //         if (type === 'ball') {
            //             type = `${type} ${this.CodeColor(str)}`
            //         }
            //         if (type === 'text') {
            //             type = `${type} ${{'红': 'red', '蓝': 'blue', '绿': 'green'}[str.substr(0, 1)]}`
            //         }
            //     }
            //     return type
            // },
        },
        // Checkbox(e,id){
        //     if(e && this.radio){
        //         for(let item of this.list){
        //             if(item.id !== id){
        //                 this.$set(item,'pick',false)
        //             }
        //         }
        //     }
        // },
        // Checkbox2(e,pack){
        //     if(e && this.radio){
        //         for(let item of this.list){
        //             if(item.id !== pack.id){
        //                 this.$set(item,'pick',false)
        //             }
        //         }
        //     }
        // },
        RebateSetGroup(item, type, key = "odds") {
            let input = Number(this.client.board.stepdir[item.group_mark])
            this.RebateSet(item, type, null, input, key)
        },
        Pick(item) {
            if (this.disabled) return false
            this.$set(item, 'pick', !item.pick)
            this.$emit('pick', item)
        },
        ShowDetails(item, integration) {
            if (this.disabled) return false
            this.Details(item, integration)
        }
    },
    components: {

    }
}